module.exports = __webpack_public_path__ + "static/media/left-underline.d303566c.svg";